const request = {}

request.createRequest = function (params) {
  return params
}
export default { request }
